import { EErrorNotificationId } from 'config/ui/error-collection';

const CAPACITY_REASON = 'NO_INSTANCES_AVAILABLE';
const BASE_DELAY_MS = 5_000;
const MAX_DELAY_MS = 60_000;

/**
 * AVS-4460: a joiner (customer or second dealer, `isSessionHost === false`) whose deck finds no
 * streaming capacity. That is a LOCAL condition — it must not be written into shared session state.
 *
 * The exception path hands Showroom's error-collection entry (`notificationId`); the disconnected
 * path hands only `{ reason }`. Both count.
 */
export function isJoinerCapacityError(errorData: Record<string, unknown>, isSessionHost: boolean): boolean {
  if (isSessionHost) return false;
  return (
    errorData.notificationId === EErrorNotificationId.NO_INSTANCES_AVAILABLE || errorData.reason === CAPACITY_REASON
  );
}

/** Backoff for the joiner's deck retry: 5 s, 10 s, 20 s, 40 s, then 60 s for every later attempt. */
export function capacityRetryDelayMs(attempt: number): number {
  return Math.min(BASE_DELAY_MS * 2 ** Math.max(0, attempt), MAX_DELAY_MS);
}

/** AVS-4460: the 4th failed attempt (index 3) is when the joiner is asked whether to keep waiting for 3D. */
export const CAPACITY_CUTOFF_ATTEMPT = 3;

/** True only on the cutoff attempt, so the prompt opens once per wait cycle. */
export function isCapacityCutoff(attempt: number): boolean {
  return attempt === CAPACITY_CUTOFF_ATTEMPT;
}
